export default __webpack_public_path__ + "static/media/Coronal Helm.ba588945.jpg";